const warningShownKeys = new Set<string>();

function hasShownWarning(key: string): boolean {
  return warningShownKeys.has(key);
}

function markWarningShown(key: string): void {
  warningShownKeys.add(key);
}

function resetWarningShownTracker(): void {
  warningShownKeys.clear();
}

export { hasShownWarning, markWarningShown, resetWarningShownTracker };
